// Main Authentication Service
// This is the main entry point for all authentication-related functionality

export { googleAuthService } from './google-auth.js';
export { authGuardService } from './auth-guard.js';

// Re-export for convenience
import { googleAuthService } from './google-auth.js';
import { authGuardService } from './auth-guard.js';

export { googleAuthService as authService };

// Initialize authentication when the module is loaded
export async function initializeAuth() {
  try {
    await googleAuthService.initialize();
    console.log('Authentication services initialized');
    return true;
  } catch (error) {
    console.error('Failed to initialize authentication:', error);
    return false;
  }
}

// Check if user is authenticated
export function isAuthenticated() {
  return googleAuthService.isSignedIn();
}

// Get current user
export function getCurrentUser() {
  return googleAuthService.getUserInfo();
}

// Sign in user
export async function signIn() {
  return await googleAuthService.signIn();
}

// Sign out user
export async function signOut() {
  return await googleAuthService.signOut();
}

// Ensure user is authenticated before proceeding
export async function requireAuth() {
  return await authGuardService.ensureAuthenticated();
}